<template>
  <div class="admin-complaint">
    <page-title title="筛选">
      <el-row :gutter="20" class="admin-complaint__filter-header">
        <el-col :span="5">
          <span>投诉编号：</span>
          <el-input v-model="filter.complaintId" placeholder="请输入"></el-input>
        </el-col>
        <!-- 商品投诉 -->
        <el-col v-if="tableType" :span="5">
          <span>商品名称：</span>
          <el-input v-model="filter.goodsName" placeholder="请输入"></el-input>
        </el-col>
        <!-- 店铺投诉 -->
        <el-col v-else :span="5">
          <span>订单编号：</span>
          <el-input v-model="filter.orderId" placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="4">
          <span>买家昵称：</span>
          <el-input v-model="filter.buyerName" placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="5">
          <span>投诉类型：</span>
          <el-select clearable v-model="filter.type" placeholder="请选择">
            <!-- <el-option v-for="ct in COMPLAINT_TYPE_ZH" :value="ct" :label="ct" :key="ct"></el-option> -->
            <el-option v-for="ct in COMPLAINT_TYPE" :value="ct" :label="COMPLAINT_TYPE_ZH[ct]" :key="ct"></el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <span>处理状态：</span>
          <el-select clearable v-model="filter.handleState" placeholder="请选择">
            <el-option v-for="h in HANDLE_STATE" :value="h" :label="HANDLE_STATE_ZH[h]" :key="h"></el-option>
          </el-select>
        </el-col>
        <el-col :span="7">
          <span>投诉时间区间：</span>
          <el-date-picker
            v-model="rangeDate"
            type="daterange"
            range-separator="-"
            start-placeholder="请选择"
            end-placeholder="请选择"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="3">
          <el-button :disabled="loading" @click="getList">查询</el-button>
          <el-button @click="filter = { applyTime: '' };currentPage=1;getList()">重置</el-button>
        </el-col>
      </el-row>
    </page-title>
    <page-title>
      <div slot="title" class="table-menu-header">
        <span :class="['title-item', `${tableType === 0 ? 'selected' : ''}`]" @click="changeTable(0)">
          投诉店铺
        </span>
        <span :class="['title-item', `${tableType === 1 ? 'selected' : ''}`]" @click="changeTable(1)">
          投诉商品
        </span>
      </div>
      <div class="admin-complaint__body">
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          :header-cell-style="{ backgroundColor: `#f7f7f7` }"
          v-show="!tableType"
        >
          <el-table-column type="index" min-width="60" align="center"> </el-table-column>
          <el-table-column prop="complaintNo" label="投诉编号" min-width="125"> </el-table-column>
          <el-table-column prop="order.orderNo" label="订单编号" min-width="185"> </el-table-column>
          <el-table-column label="买家昵称" min-width="165">
            <template slot-scope="{ row }">
              <i class="el-icon-circle el-icon-user-solid" style="background-color:#00bd83"></i>
              <span>{{ row.buyerNickName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="店铺名称" min-width="165">
            <template slot-scope="{ row }">
              <i class="el-icon-circle el-icon-s-shop" style="background-color:#005bff"></i>
              <span>{{ row.order && row.order.store.name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="投诉类型" min-width="150">
            <template slot-scope="{ row }">
              <span> {{ COMPLAINT_TYPE_ZH[row.type] }} </span>
            </template>
          </el-table-column>
          <el-table-column prop="applyTime" label="投诉时间" min-width="185"> </el-table-column>
          <el-table-column label="处理状态" min-width="150">
            <template slot-scope="{ row }">
              <handle-label :state="row.handleState"></handle-label>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" min-width="90">
            <template slot-scope="{ row }">
              <router-link style="text-decoration:none;color:#005BFF;" :to="`/complaint/${row.id}/shop`">
                <span>详情</span>
              </router-link>
            </template>
          </el-table-column>
        </el-table>
        <el-table
          :data="tableData"
          style="width: 100%"
          :header-cell-style="{ backgroundColor: `#f7f7f7` }"
          v-show="tableType"
          v-loading="loading"
        >
          <el-table-column type="index" min-width="60" align="center"> </el-table-column>
          <el-table-column prop="complaintNo" label="投诉编号" min-width="140"> </el-table-column>
          <el-table-column label="买家昵称" min-width="160">
            <template slot-scope="{ row }">
              <i class="el-icon-circle el-icon-user-solid" style="background-color:#00bd83"></i>
              <span>{{ row.buyerNickName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="spu.name" label="商品名称" min-width="165"></el-table-column>
          <el-table-column label="投诉类型" width="175">
            <template slot-scope="{ row }">
              {{ COMPLAINT_TYPE_ZH[row.type] }}
            </template>
          </el-table-column>
          <el-table-column prop="applyTime" label="投诉时间" min-width="175"> </el-table-column>
          <el-table-column label="处理状态" min-width="140">
            <template slot-scope="{ row }">
              <div v-if="row.handleState === 'TO_HANDLE'">
                <i class="el-icon-circle el-icon-time" style="background-color:#005bff"></i>
                <span style="color:#005bff">待处理</span>
              </div>
              <div v-else>
                <i class="el-icon-circle el-icon-circle-check" style="background-color:#888888"></i>
                <span style="color:#888888">已处理</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" min-width="90">
            <template slot-scope="{ row }">
              <router-link style="text-decoration:none;color:#005BFF;" :to="`/complaint/${row.id}/goods`">
                <span>详情</span>
              </router-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <cus-pagination :total="total" :current-page.sync="currentPage" :page-size.sync="pageSize"></cus-pagination>
    </page-title>
  </div>
</template>

<script>
import PageTitle from '@/components/pageTitle.vue';
import CusPagination from '@/components/cusPagination.vue';
import HandleLabel from './components/handleLabel.vue';
import { getSpuComplaintList, getStoreComplaintList } from '@/api/req';
import { COMPLAINT_TYPE_ZH, HANDLE_STATE, HANDLE_STATE_ZH, COMPLAINT_TYPE } from './_eum';

const TABLETYPE = {
  SHOP: 0,
  GOODS: 1
};
export default {
  components: { PageTitle, CusPagination, HandleLabel },
  name: 'complaint',
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      filter: {
        applyTime: ''
      },
      loading: true,
      tableType: TABLETYPE.SHOP,
      tableData: []
    };
  },
  computed: {
    COMPLAINT_TYPE_ZH: () => COMPLAINT_TYPE_ZH,
    COMPLAINT_TYPE: () => COMPLAINT_TYPE,
    HANDLE_STATE: () => HANDLE_STATE,
    HANDLE_STATE_ZH: () => HANDLE_STATE_ZH,
    rangeDate: {
      get() {
        return this.filter.applyTime.split(',') || '';
      },
      set(val) {
        this.filter.applyTime = val ? val.join(',') : '';
      }
    }
  },
  watch: {
    currentPage() {
      this.getList();
    },
    '$route.query.type'(type) {
      this.tableData = [];
      this.filter = { applyTime: '' };
      if (this.$route.query.type !== undefined) this.tableType = +type;
      this.getList();
    }
  },
  methods: {
    getList() {
      this.loading = true;
      const { currentPage: pageNumber, pageSize } = this;
      if (this.tableType === TABLETYPE.SHOP) {
        const req = { pageNumber, pageSize, ...this.filter };
        // if (req.type) {
        //   req.type = COMPLAINT_TYPE_ZH[req.type];
        // }
        this.$ajax
          .get(getStoreComplaintList, req)
          .then(({ data }) => {
            this.loading = false;
            this.tableData = Object.freeze(data.rows);
            this.total = data.total;
          })
          .catch((err) => {
            this.loading = false;
            console.log(err.data);
            this.$message.info('获取数据失败！');
          });
      } else {
        const req = { pageNumber, pageSize, ...this.filter };
        this.$ajax
          .get(getSpuComplaintList, req)
          .then(({ data }) => {
            this.loading = false;
            this.tableData = Object.freeze(data.rows);
            this.total = data.total;
          })
          .catch((err) => {
            this.loading = false;
            console.log(err.data);
            this.$message.info('获取数据失败！');
          });
      }
    },
    changeTable(type) {
      this.$router.replace({ query: { type } });
    }
  },
  created() {
    if (this.$route.query.type != undefined) {
      if (this.$route.query.type == 0) {
        this.tableType = 0;
      } else if (this.$route.query.type == 1) {
        this.tableType = 1;
      }
    }
    this.getList();
  }
};
</script>

<style lang="scss">
.admin-complaint {
  .table-menu-header {
    .title-item {
      margin-right: 40px;
      font-size: 12px;
      color: #8998a0;
      cursor: pointer;
    }
    .title-item.selected {
      font-size: 14px;
      color: #040b28;
    }
  }
  &__body {
    .el-table {
      border: 1px solid #ebeef5;
      border-bottom: none;
      margin-bottom: 20px;
    }
    .el-icon-circle {
      margin-right: 8px;
      color: #fff;
      vertical-align: middle;
    }
  }
}
</style>
